<template>

  <ContentWrap>
    <!-- 搜索工作栏 -->
    <el-form
      ref="queryFormRef"
      :inline="true"
      :model="queryParams"
      class="-mb-15px"
      label-width="85px"
    >
      <el-form-item label="推广员编号" prop="bindUserId">
        <el-input
          v-model="queryParams.bindUserId"
          class="!w-240px"
          clearable
          placeholder="请输入推广员编号"
          @keyup.enter="handleQuery"
        />
      </el-form-item>
      <el-form-item label="推广资格" prop="brokerageEnabled">
        <el-select
          v-model="queryParams.brokerageEnabled"
          class="!w-240px"
          clearable
          placeholder="请选择推广资格"
        >
          <el-option :value="true" label="有" />
          <el-option :value="false" label="无" />
        </el-select>
      </el-form-item>
      <el-form-item label="申请状态" prop="applyStatus">
        <el-select
          v-model="queryParams.applyStatus"
          class="!w-240px"
          clearable
          placeholder="请选择申请状态"
        >
          <el-option :value="0" label="未申请" />
          <el-option :value="1" label="待审核" />
          <el-option :value="2" label="已通过" />
          <el-option :value="3" label="已驳回" />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间" prop="createTime">
        <el-date-picker
          v-model="queryParams.createTime"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-240px"
          end-placeholder="结束日期"
          start-placeholder="开始日期"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="filterPending">待审核</el-button>
        <el-button @click="handleQuery">
          <Icon class="mr-5px" icon="ep:search" />
          搜索
        </el-button>
        <el-button @click="resetQuery">
          <Icon class="mr-5px" icon="ep:refresh" />
          重置
        </el-button>
        <el-button
          v-hasPermi="['distribution:brokerage-user:create']"
          plain
          type="primary"
          @click="openCreateUserForm"
        >
          <Icon class="mr-5px" icon="ep:plus" />
          新增
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <!-- 列表 -->
  <ContentWrap>
    <el-table v-loading="loading" :data="list" :show-overflow-tooltip="true" :stripe="true">
      <el-table-column align="center" label="用户编号" min-width="80px" prop="id" />
      <el-table-column align="center" label="头像" prop="avatar" width="70px">
        <template #default="scope">
          <el-avatar :src="scope.row.avatar" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="昵称" min-width="80px" prop="nickname" />
      <el-table-column align="center" label="推广人数" prop="brokerageUserCount" width="80px" />
      <el-table-column
        align="center"
        label="推广订单数量"
        min-width="110px"
        prop="brokerageOrderCount"
      />
      <el-table-column
        :formatter="fenToYuanFormat"
        align="center"
        label="推广订单金额"
        min-width="110px"
        prop="brokerageOrderPrice"
      />
      <el-table-column
        :formatter="fenToYuanFormat"
        align="center"
        label="已提现金额"
        min-width="100px"
        prop="withdrawPrice"
      />
      <el-table-column align="center" label="已提现次数" min-width="100px" prop="withdrawCount" />
      <el-table-column
        :formatter="fenToYuanFormat"
        align="center"
        label="未提现金额"
        min-width="100px"
        prop="price"
      />
      <el-table-column
        :formatter="fenToYuanFormat"
        align="center"
        label="冻结中佣金"
        min-width="100px"
        prop="frozenPrice"
      />
      <el-table-column align="center" label="推广资格" min-width="80px" prop="brokerageEnabled">
        <template #default="scope">
          <el-switch
            v-model="scope.row.brokerageEnabled"
            :disabled="!checkPermi(['distribution:brokerage-user:update-bind-user'])"
            active-text="有"
            inactive-text="无"
            inline-prompt
            @change="handleBrokerageEnabledChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column align="center" label="申请状态" min-width="100px" prop="applyStatus">
        <template #default="scope">
          <el-tag v-if="scope.row.applyStatus === 1" type="warning">待审核</el-tag>
          <el-tag v-else-if="scope.row.applyStatus === 2" type="success">已通过</el-tag>
          <el-tag v-else-if="scope.row.applyStatus === 3" type="danger">已驳回</el-tag>
          <el-tag v-else type="info">未申请</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="申请姓名" min-width="90px" prop="applyRealName" />
      <el-table-column align="center" label="申请手机" min-width="110px" prop="applyMobile" />
      <el-table-column align="center" label="银行名称" min-width="110px" prop="applyBankName" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="成为推广员时间"
        prop="brokerageTime"
        width="180px"
      />
      <el-table-column align="center" label="上级推广员编号" prop="bindUserId" width="150px" />
      <el-table-column
        :formatter="dateFormatter"
        align="center"
        label="推广员绑定时间"
        prop="bindUserTime"
        width="180px"
      />
      <el-table-column align="center" fixed="right" label="操作" width="300px">
        <template #default="scope">
          <el-button
            v-if="scope.row.applyStatus === 1 && checkPermi(['distribution:brokerage-user:update-brokerage-enable'])"
            link
            type="primary"
            @click="openAuditDialog(scope.row)"
          >
            审核
          </el-button>
          <el-button
            v-if="
              (scope.row.applyStatus === 2 || scope.row.applyStatus === 3) &&
              checkPermi(['distribution:brokerage-user:query'])
            "
            link
            type="primary"
            @click="openAuditDialog(scope.row)"
          >
            查看材料
          </el-button>
          <el-button
            v-if="
              flexworkEnabled &&
              scope.row.applyStatus === 2 &&
              checkPermi(['distribution:brokerage-user:update-brokerage-enable'])
            "
            link
            type="warning"
            @click="handleSyncFlexwork(scope.row)"
          >
            同步灵工
          </el-button>
          <el-dropdown
            v-hasPermi="[
              'distribution:brokerage-user:user-query',
              'distribution:brokerage-user:order-query',
              'distribution:brokerage-user:update-bind-user',
              'distribution:brokerage-user:clear-bind-user'
            ]"
            @command="(command) => handleCommand(command, scope.row)"
          >
            <el-button link type="primary">
              <Icon icon="ep:d-arrow-right" />
              更多
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  v-if="checkPermi(['distribution:brokerage-user:user-query'])"
                  command="openBrokerageUserTable"
                >
                  推广人
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermi(['distribution:brokerage-user:order-query'])"
                  command="openBrokerageOrderTable"
                >
                  推广订单
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="checkPermi(['distribution:brokerage-user:update-bind-user'])"
                  command="openUpdateBindUserForm"
                >
                  修改上级推广人
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    scope.row.bindUserId && checkPermi(['distribution:brokerage-user:clear-bind-user'])
                  "
                  command="handleClearBindUser"
                >
                  清除上级推广人
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
      v-model:limit="queryParams.pageSize"
      v-model:page="queryParams.pageNo"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>
  <!-- 修改上级推广人表单 -->
  <BrokerageUserUpdateForm ref="updateFormRef" @success="getList" />
  <!-- 推广人列表 -->
  <BrokerageUserListDialog ref="listDialogRef" />
  <!-- 推广订单列表 -->
  <BrokerageOrderListDialog ref="orderDialogRef" />
  <!-- 创建分销员 -->
  <BrokerageUserCreateForm ref="createFormRef" @success="getList" />
  <!-- 分销申请审核 -->
  <BrokerageUserAuditDialog ref="auditDialogRef" @success="getList" />
</template>

<script lang="ts" setup>
import { dateFormatter } from '@/utils/formatTime'
import * as BrokerageUserApi from '@/api/mall/trade/brokerage/user'
import { checkPermi } from '@/utils/permission'
import { fenToYuanFormat } from '@/utils/formatter'
import { DynamicRouterRegistry } from '@/router/modules/dynamic'
import BrokerageUserUpdateForm from '@/views/distribution/brokerage/user/BrokerageUserUpdateForm.vue'
import BrokerageUserListDialog from '@/views/distribution/brokerage/user/BrokerageUserListDialog.vue'
import BrokerageOrderListDialog from '@/views/distribution/brokerage/user/BrokerageOrderListDialog.vue'
import BrokerageUserCreateForm from '@/views/distribution/brokerage/user/BrokerageUserCreateForm.vue'
import BrokerageUserAuditDialog from '@/views/distribution/brokerage/user/BrokerageUserAuditDialog.vue'

defineOptions({ name: 'TradeBrokerageUser' })

const message = useMessage() // 消息弹窗

/** 租户已启用灵工模块时才展示「同步灵工」 */
const flexworkEnabled = computed(() => DynamicRouterRegistry.isModuleEnabled('flexwork'))

const loading = ref(true) // 列表的加载中
const total = ref(0) // 列表的总页数
const list = ref<BrokerageUserApi.BrokerageUserVO[]>([]) // 列表的数据
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  bindUserId: null,
  brokerageEnabled: undefined as boolean | undefined,
  applyStatus: undefined as number | undefined,
  createTime: []
})
const queryFormRef = ref() // 搜索的表单

/** 查询列表 */
const getList = async () => {
  loading.value = true
  try {
    const data = await BrokerageUserApi.getBrokerageUserPage(queryParams)
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

/** 打开分销申请审核弹窗 */
const auditDialogRef = ref<InstanceType<typeof BrokerageUserAuditDialog>>()
const openAuditDialog = (row: BrokerageUserApi.BrokerageUserVO) => {
  auditDialogRef.value?.open(row)
}

/** 手动同步灵工（仅已通过） */
const handleSyncFlexwork = async (row: BrokerageUserApi.BrokerageUserVO) => {
  try {
    await message.confirm(`确认将「${row.nickname || row.id}」同步到灵工？`)
    await BrokerageUserApi.syncFlexworkDistributor(row.id)
    message.success('同步成功')
  } catch {}
}

/** 搜索按钮操作 */
const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

/** 快捷：仅看待审核申请 */
const filterPending = () => {
  queryParams.brokerageEnabled = undefined
  queryParams.applyStatus = 1
  queryParams.pageNo = 1
  getList()
}

/** 重置按钮操作 */
const resetQuery = () => {
  queryFormRef.value.resetFields()
  handleQuery()
}

const handleCommand = (command: string, row: BrokerageUserApi.BrokerageUserVO) => {
  switch (command) {
    case 'openBrokerageUserTable':
      openBrokerageUserTable(row.id)
      break
    case 'openBrokerageOrderTable':
      openBrokerageOrderTable(row.id)
      break
    case 'openUpdateBindUserForm':
      openUpdateBindUserForm(row)
      break
    case 'handleClearBindUser':
      handleClearBindUser(row)
      break
  }
}

/** 打开推广人列表 */
const listDialogRef = ref()
const openBrokerageUserTable = (id: number) => {
  listDialogRef.value.open(id)
}

/** 打开推广订单列表 */
const orderDialogRef = ref()
const openBrokerageOrderTable = (id: number) => {
  orderDialogRef.value.open(id)
}

/** 打开表单：修改上级推广人 */
const updateFormRef = ref()
const openUpdateBindUserForm = (row: BrokerageUserApi.BrokerageUserVO) => {
  updateFormRef.value.open(row)
}

/** 创建分销员 */
const createFormRef = ref<InstanceType<typeof BrokerageUserCreateForm>>()
const openCreateUserForm = () => {
  createFormRef.value?.open()
}

/** 清除上级推广人 */
const handleClearBindUser = async (row: BrokerageUserApi.BrokerageUserVO) => {
  try {
    // 二次确认
    await message.confirm(`确认要清除"${row.nickname}"的上级推广人吗？`)
    // 发起修改
    await BrokerageUserApi.clearBindUser({ id: row.id })
    message.success('清除成功')
    // 刷新列表
    await getList()
  } catch {}
}

/** 推广资格：开通/关闭 */
const handleBrokerageEnabledChange = async (row: BrokerageUserApi.BrokerageUserVO) => {
  try {
    // 二次确认
    const text = row.brokerageEnabled ? '开通' : '关闭'
    await message.confirm(`确认要${text}"${row.nickname}"的推广资格吗？`)
    // 发起修改
    await BrokerageUserApi.updateBrokerageEnabled({ id: row.id, enabled: row.brokerageEnabled })
    message.success(text + '成功')
    // 刷新列表
    await getList()
  } catch {
    // 异常时，需要重置回之前的值
    row.brokerageEnabled = !row.brokerageEnabled
  }
}

/** 初始化 **/
onMounted(() => {
  getList()
})
</script>

